import { StyleSheet, Text, View } from 'react-native';

export interface BadgeProps {
  label: string;
  variant?: 'default' | 'setup' | 'progress' | 'completed';
  colors: {
    text: string;
    badgeSetup: string;
    badgeProgress: string;
    badgeCompleted: string;
  };
}

export const Badge = ({ label, variant = 'default', colors }: BadgeProps) => {
  const getBackgroundColor = () => {
    switch (variant) {
      case 'setup':
        return colors.badgeSetup;
      case 'progress':
        return colors.badgeProgress;
      case 'completed':
        return colors.badgeCompleted;
      default:
        return colors.badgeSetup;
    }
  };

  return (
    <View style={[styles.badge, { backgroundColor: getBackgroundColor() }]}>
      <Text style={[styles.text, { color: colors.text }]}>{label}</Text>
    </View>
  );
};

const styles = StyleSheet.create({
  badge: {
    paddingHorizontal: 12,
    paddingVertical: 6,
    borderRadius: 12,
  },
  text: {
    fontSize: 12,
    fontWeight: '600',
    textTransform: 'capitalize',
  },
});
